import { mockReferralDB } from './mockDb';
import type { Payout, PayoutFormData } from '../types';
import { exportCommissionsToCSV } from '../utils/referralUtils';

export const payoutService = {
  async getAll(): Promise<Payout[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getPayouts();
  },

  async getById(id: string): Promise<Payout> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const payout = mockReferralDB.getPayout(id);
    if (!payout) throw new Error('Payout not found');
    return payout;
  },

  async getByReferrer(referrerId: string): Promise<Payout[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getPayoutsByReferrer(referrerId);
  },

  async create(data: PayoutFormData): Promise<Payout> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const payout = mockReferralDB.createPayout({
      ...data,
      date: new Date().toISOString(),
    });

    for (const entryId of data.commissionEntryIds) {
      mockReferralDB.updateCommissionEntry(entryId, { payoutStatus: 'paid' });
    }

    return payout;
  },

  async exportStaffCommissions(): Promise<string> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const allEntries = mockReferralDB.getCommissionEntries();
    const staffEntries = allEntries.filter(entry => entry.referrer.kind === 'internal_staff');
    
    const enrichedEntries = staffEntries.map(entry => {
      const staff = mockReferralDB.getStaffMember(entry.referrer.id);
      return {
        ...entry,
        referrer: {
          ...entry.referrer,
          name: staff?.name || 'Unknown Staff',
          empCode: staff?.empCode || '',
          role: staff?.role || '',
        },
      };
    });

    return exportCommissionsToCSV(enrichedEntries);
  },

  async exportPartnerCommissions(partnerId?: string): Promise<string> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const allEntries = mockReferralDB.getCommissionEntries();
    let partnerEntries = allEntries.filter(entry => entry.referrer.kind === 'external_partner');
    
    if (partnerId) {
      partnerEntries = partnerEntries.filter(entry => entry.referrer.id === partnerId);
    }
    
    const enrichedEntries = partnerEntries.map(entry => {
      const partner = mockReferralDB.getPartner(entry.referrer.id);
      return {
        ...entry,
        referrer: {
          ...entry.referrer,
          name: partner?.name || 'Unknown Partner',
          role: partner?.role || '',
        },
      };
    });

    return exportCommissionsToCSV(enrichedEntries);
  },
};
